export enum ReportLocationEnum {
    Sea = 1,
    Port = 2,
}
